export function getdata() {
	var obj = {
		headData: [{
				title: "项目及栏次",
				prop: "title",
				width: "70px",
				custom: true,
			},
			{
				title: "项目2",
				prop: "mintitle",
				width: "120px",
				align: "left",
				custom: true,
			},
			{
				title: "项目3",
				prop: "coloum",
				width: "250px",
				align: "left",
				custom: true,
			},
			{
				title: "栏次",
				prop: "grade",
				width: "75px",
				custom: true
			},
			{
				title: "销售额",
				prop: "xse",
				align: "left",
				width: "140px",
				custom: true,
			},
			{
				title: "销项（应纳）税额",
				prop: "ynse",
				width: "140px",
				align: "left",
				custom: true
			},
		],
		tableData: [{
				title: "一、一般计税方法计税",
				mintitle: "全部征税项目",
				coloum: "13%税率的货物及加工修理修配劳务",
				grade: "1",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "全部征税项目",
				coloum: "13%税率的服务、不动产和无形资产",
				grade: "2",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "全部征税项目",
				coloum: "9%税率的货物及加工修理修配劳务",
				grade: "3",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "全部征税项目",
				coloum: "9%税率的服务、不动产和无形资产",
				grade: "4",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "全部征税项目",
				coloum: "6%税率",
				grade: "5",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "其中：即征即退项目",
				coloum: "即征即退货物及加工修理修配劳务",
				grade: "6",

			},
			{
				title: "一、一般计税方法计税",
				mintitle: "其中：即征即退项目",
				coloum: "即征即退服务、不动产和无形资产",
				grade: "7",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "6%征收率",
				grade: "8",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "5%征收率的货物及加工修理修配劳务",
				grade: "9a",
			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "5%征收率的服务、不动产和无形资产",
				grade: "9b",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "4%征收率",
				grade: "10",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "3%征收率的货物及加工修理修配劳务",
				grade: "11",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "3%征收率的服务、不动产和无形资产",
				grade: "12",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "预征率   %",
				grade: "13a",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "预征率   %",
				grade: "13b",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "全部征税项目",
				coloum: "预征率   %",
				grade: "13c",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "其中：即征即退项目",
				coloum: "即征即退货物及加工修理修配劳务",
				grade: "14",

			},
			{
				title: "二、简易计税方法计税",
				mintitle: "其中：即征即退项目",
				coloum: "即征即退服务、不动产和无形资产",
				grade: "15",

			},
			{
				title: "三、免抵退税",
				mintitle: "货物及加工修理修配劳务",
				coloum: "",
				grade: "16",

			},
			{
				title: "三、免抵退税",
				mintitle: "服务、不动产和无形资产",
				coloum: "",
				grade: "17",

			},
			{
				title: "四、免税",
				mintitle: "货物及加工修理修配劳务",
				coloum: "",
				grade: "18",

			},
			{
				title: "四、免税",
				mintitle: "服务、不动产和无形资产",
				coloum: "",
				grade: "19",

			}
		]
	}
	return obj
}
